var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-content",on:{"click":_vm.handleClick}},[_c('Head',{ref:"head",attrs:{"backFn":_vm.back}}),_c('blog-list'),(_vm.isMaxScreen)?_c('bottom',{ref:"bottom",attrs:{"showArrow":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }